import React, { useEffect, useCallback } from "react"
import { useParams, useSearchParams, Outlet, useNavigate } from "react-router-dom"
import { Component } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { NavTabset } from "lib/components"

export default function TemplateWrapper({ children }:any){
  const navigate = useNavigate()
  const { tmplid, tab } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams();
  
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const [ activeTab, setActiveTab ] = React.useState<string>()

  const setCurrentTemplate = useCallback( () => {
    if( _Template ){
      const { _id, Id, AssignedTo, Title, VersionNumber, IsActive } = _Template || {}
      update("template", { _id:_Template._id, Id: _Template.Id, AssignedTo: _Template.AssignedTo, Title: _Template.Title, VersionNumber: _Template.VersionNumber, IsActive: _Template.IsActive })
    }
  },[_Template])
  
  const handleTabClick = (tab:string) => {
    navigate(`/template/${tmplid}/${tab.toLowerCase()}`)
  }

  useEffect(() => {
    setActiveTab(window.location.href.split("/").pop()?.split("?")[0] || "Build")
  },[window.location.href])

  useEffect(() => {
    if( tmplid && !store.template ){
      setCurrentTemplate()
    }
  },[setCurrentTemplate])

  useEffect(() => {
    const elem = searchParams.get("elem")
    if( elem !== store.element.refstr ){
      update("element", { refstr: elem })
    }
  },[searchParams, store.element])

  if( !_Template ) return <></>
  return (
    <div className="w-full h-full flex flex-col justify-start items-start pt-6">

      <div className="w-full flex justify-between items-center border-b border-solid border-slate-700 pb-1 mb-10">
        <span
          className="text-[1.5rem] uppercase tracking-widest cursor-pointer" 
          onClick={() => {
            update("actives.statement", null)
            searchParams.delete("elem")
            setSearchParams(searchParams)
          }}
        >
          { _Template.Title }
        </span>
        <div className="flex justify-end items-center uppercase gap-6">
          { _Template.AssignedTo !== null && (
            <span className="text-lg">Owner: { _Template.AssignedTo?.name }</span>
          )}
          <span className="text-lg">Usage: { _Template.Usage || "General" }</span>
        </div>
      </div>

      <div className="w-full h-full">
        <div className="w-full flex justify-between items-center pb-1 mb-2 gap-3">
          { ["Setup", "Build", "Preview"].map( (tabname:string) => (
            <div 
              key={tabname} 
              onClick={() => handleTabClick(tabname)}
              className={cn(
                "flex grow justify-center border-b-2 border-solid border-slate-700 cursor-pointer",
                tabname.toLowerCase() === activeTab && "border-yellow-500"
              )}
            >
              <span>{tabname}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="w-full">
        <Outlet />
      </div>
    </div>
  )
}